import Vue from 'vue'
import { mask } from 'vue-the-mask'
import VuetifyConfirm from 'vuetify-confirm'
import App from './App.vue'
import http from './http'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/element'
import dayjs from './plugins/dayjs'
import './scss/style.scss'
import eventBus from './utils/eventBus'
import './validation/validation'
import './components/mixins/accessFor'
import VueCookies from 'vue-cookies'
import CKEditor from '@ckeditor/ckeditor5-vue2'

Vue.config.productionTip = false
Vue.prototype.$eventBus = eventBus
Vue.prototype.$http = http
Vue.prototype.$dayjs = dayjs
Vue.directive('mask', mask)
Vue.use(VuetifyConfirm, { vuetify })
Vue.use(VueCookies)
Vue.use(CKEditor)

new Vue({
  router,
  store,
  vuetify,
  beforeCreate() {
    this.$store.dispatch('initialiseStore')
  },
  render: (h) => h(App),
}).$mount('#app')
